import type { RepositoryIndexingRun } from "../types";

export function formatTimestamp(value: number | null): string {
  if (!value) {
    return "—";
  }
  try {
    // Input is expected to be in seconds (Unix timestamp), convert to milliseconds
    return new Date(value * 1000).toLocaleString();
  } catch {
    return "—";
  }
}

export function buildOptimisticRunPlaceholder(
  runId: string,
): RepositoryIndexingRun {
  const now = Math.floor(Date.now() / 1000);
  return {
    completed_at: null,
    created_at: now,
    insight_count: 0,
    item_counts: {
      failed: 0,
      pending: 0,
      queued: 0,
      running: 0,
      succeeded: 0,
      total: 0,
    },
    metadata: { requestedFrom: "dashboard", trigger: "manual" },
    repository_count: null,
    requested_by: "dashboard/manual",
    run_id: runId,
    run_type: "repository-indexing/smart",
    scope: null,
    started_at: now,
    status: "running",
    updated_at: now,
  };
}
